import { recordingToRibbon2Asset } from './RecordingConversions';
import { CardDataSource } from '../cms/CardDataSource';
import { ActionMethod, AssetType } from '../../api/models/Shared.types';
import { Backend } from '../../api/Backend';
import { Recording } from '../../api/user/RecordingApi.types';
import { ChannelModel } from '../../api/EpgApi.types';
import { CardSizeInfo } from '../cms/CardSizeInfo';
import { IAssetAction, IRibbon2Asset } from '../../api/models/AndromeTV.types';

export class RecordingCardDataSource {
  private backend: Backend;
  private recordings: Recording[];
  private channels: ChannelModel[];
  private sizeInfo: CardSizeInfo;
  private properties: string[];
  private pageType: string;
  private ds: CardDataSource | undefined;
  private asset: IRibbon2Asset | undefined;
  constructor(
    backend: Backend,
    recordings: Recording[],
    channels: ChannelModel[],
    sizeInfo: CardSizeInfo,
    properties: string[],
    pageType = ''
  ) {
    this.backend = backend;
    this.recordings = recordings;
    this.channels = channels;
    this.sizeInfo = sizeInfo;
    this.properties = properties;
    this.pageType = pageType;
  }

  get datasource() {
    return this.ds;
  }

  /**
   * @returns {Promise<IRibbon2Asset>}
   */
  toRibbon2Asset(): Promise<IRibbon2Asset | undefined> {
    if (this.recordings && this.recordings.length > 0 && this.recordings[0]) {
      return recordingToRibbon2Asset(this.backend, this.recordings[0]).then(info => {
        this.asset = info;
        this.ds = new CardDataSource(
          this.backend,
          this.asset,
          this.sizeInfo,
          this.properties,
          this.channels,
          this._action()
        );
        this.ds.nrOfRecordings = this.recordings.length;
        return info;
      });
    } else {
      return Promise.resolve(undefined);
    }
  }

  /**
   * @returns {IAssetAction}
   * @private
   */
  _action(): IAssetAction | undefined {
    if (this.asset?.asset.type === AssetType.RECORDING && this.recordings.length > 1) {
      return {
        method: ActionMethod.OPEN_FOLDER,
        type: AssetType.RECORDING,
        id: this.asset.asset.id,
        extra: {
          seriesId: this.recordings[0]?.series,
          channelId: this.recordings[0]?.channel,
          pageType: this.pageType,
        },
      };
    }
    return undefined;
  }
}
